<template>
    <a-modal v-model:visible="visible" title="切换部门和租户" okText="确认" okType="primary" width="800px" @ok="onFinish">
        <a-form :layout="'horizontal'" ref="formRef" :model="formData" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-form-item label="租户:" v-if="tenantDownArr.length > 0">
                <a-select allowClear v-model:value="formData.tenant_id" placeholder="请选择租户">
                    <a-select-option v-for="item in tenantDownArr" :key="item.id" :value="item.id">{{
                        item.label }}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="部门:" v-if="depDownArr.length > 0">
                <a-select allowClear v-model:value="formData.dep_id" placeholder="请选择部门">
                    <a-select-option v-for="item in depDownArr" :key="item.id" :value="item.id">{{
                        item.label }}</a-select-option>
                </a-select>
            </a-form-item>
        </a-form>
    </a-modal>
</template>
<script  setup>
import { onMounted, ref } from "vue";
import { getDepartApi, getTenantApi, updateDepTenatApi } from '@/api/homePageApi/homePageApi'
import { message } from "ant-design-vue";
import { getPermissionApi } from "@/api/homePageApi/homePageApi";



const labelCol = {
    span: 4, // label 标签占据的列数，默认为 6
};

const wrapperCol = {
    span: 18, // 表单控件占据的列数，默认为 16
};
const visible = ref(true)
const formData = ref({
    dep_id: undefined,//部门id
    tenant_id: undefined  //租户
})
//部门下拉
const depDownArr = ref([])
//租户下拉
const tenantDownArr = ref([])
// //请求
const initFn = () => {
    //部门下拉请求
    getDepartApi().then(res => {
        depDownArr.value = res.data.map(item => {
            return { label: item.depart_name, id: item.id }
        })
    })
    //租户下拉请求
    getTenantApi().then(res => {
        tenantDownArr.value = res.data.map(item => {
            return { label: item.name, id: item.id }
        })
    })
}
const onFinish = () => {
    const param = {
        dep_id: formData.value.dep_id,
        tenant_id: formData.value.tenant_id,
    }
    updateDepTenatApi(param).then(() => {
        // console.log(res)
        getPermissionApi()
        message.success('操作成功')
        visible.value = false
    }).catch(err => {
        message.error(err)
    })
}



onMounted(() => {
    initFn()
})
</script>
<style scoped></style>